import type { MailboxInfo } from 'owa-client-types';
import { getAccountKeyForMailboxInfo } from 'owa-client-types';
import type { UserCohort } from 'owa-bizchat-types/lib/UserCohort';
import { getBizchatAcquisitionSettings } from './getBizchatAcquisitionSettings';

/**
 * Returns the UserCohort for the given MailboxInfo.
 */
export function getUserCohort(mailboxInfo: MailboxInfo): UserCohort | undefined {
    const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);
    return getBizchatAcquisitionSettings(accountKey)?.userCohort;
}
